import { createMeasurement, type MeasurementProps } from './createMeasurement';

export type FuelEconomyProps = MeasurementProps<'fuelConsumption'>;

/**
 * How much fuel a combustion vehicle uses, as litres per 100 km or miles per gallon.
 *
 * The two are reciprocals, so a higher number means the opposite thing in each. The conversion
 * handles that; a call site only states the unit its payload arrived in.
 */
const FuelEconomy = createMeasurement('fuelConsumption', 'FuelEconomy');

export default FuelEconomy;
